<section class="register-lp">
  <div class="topbar">
    <div class="topbar-inner container">
      <div class="brand">
        <img src="../../../assets/register/logo.png" alt="" srcset="" />
      </div>
    </div>
  </div>
  <header class="hero">
    <div class="hero-content container">
      <img
        src="../../../assets/register/hero-logo.svg"
        class="hero-content__logo"
      />
      <div class="hero-text">
        <button class="btn cta">Cadastre-se</button>
      </div>
    </div>
  </header>

  <section class="faq container">
    <h2 class="faq-title">Principais Dúvidas</h2>
    <div class="cards">
      <article class="card">
        <img
          src="../../../assets/register/icon1.png"
          alt="icon"
          class="faq-icon"
        />
        <h3 class="faq-card-title">Onde posso usar meu saldo?</h3>
        <hr class="faq-separator" />
        <p class="faq-card-text">
          Você pode utilizar seu saldo em todos os restaurantes Madero e
          Jeronimo.
        </p>
      </article>
      <article class="card">
        <img
          src="../../../assets/register/icon2.png"
          alt="icon"
          class="faq-icon"
        />
        <h3 class="faq-card-title">Como acumular saldo?</h3>
        <hr class="faq-separator" />
        <p class="faq-card-text">
          Basta frequentar os restaurantes Madero e/ou Jeronimo e sempre
          informar seu CPF no ato do pagamento para que seu consumo seja
          contabilizado.
        </p>
      </article>
      <article class="card">
        <img
          src="../../../assets/register/icon3.png"
          alt="icon"
          class="faq-icon"
        />
        <h3 class="faq-card-title">Como usar meu saldo?</h3>
        <hr class="faq-separator" />
        <p class="faq-card-text">
          Acesse sua conta no App, entre na sessão Cashback e clique no botão
          resgatar saldo para utilizar no restaurante. Esse saldo ficará
          disponível para uso até o final do dia.
        </p>
      </article>
    </div>
  </section>

  <app-registration-form
    #registrationForm
    [partnerActive]="partnerActive"
    [binActive]="binActive"
  >
  </app-registration-form>
</section>
